interface VividProgressProps {
    monthsPaid: number;
    totalMonths: number;
}

const VividProgress = ({ monthsPaid, totalMonths }: VividProgressProps) => {
    const total = totalMonths > 0 ? totalMonths : 12;
    const clamped = Math.max(0, Math.min(monthsPaid, total));
    const percent = (clamped / total) * 100;

    return (
        <div className="vivid-progress">
            <div className="vivid-progress__row">
                <span className="vivid-progress__label">Obuna jarayoni</span>
                <span className="vivid-progress__count">
                    {clamped} / {total}
                </span>
            </div>
            <div className="vivid-progress-track">
                <div className="vivid-progress-fill" style={{ width: `${percent}%` }} />
            </div>
        </div>
    );
};

export default VividProgress;
